import { render, staticRenderFns } from "./deviceMemo.vue?vue&type=template&id=08d1f782&lang=pug&"
import script from "./deviceMemo.vue?vue&type=script&lang=js&"
export * from "./deviceMemo.vue?vue&type=script&lang=js&"
import style0 from "./deviceMemo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports